import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom";
import { Menu, Dropdown, Button, AutoComplete, Input, Badge  } from 'antd';
import { AlignLeftOutlined, CloseOutlined, UserOutlined, ShoppingCartOutlined, PhoneOutlined, ImportOutlined, CaretDownOutlined } from '@ant-design/icons';
import "./Header.scss"
import { connect } from 'react-redux';
import { setCurrentUser, setCurrentLang, setAddressUser, setPaymentUser, setBrandsList } from '../../redux/user/user.action';
import { clearCart } from "../../redux/cart/cart.action";
import localization from '../../Localization/Localization.json'
import logo from "../../assets/Logo.svg"
import location_icon from "../../assets/location.svg"
import search_icon from "../../assets/search.svg" 
import { cart_icon } from '../../icons/icons';
import { fetchHome } from '../../network/home.network';
import { fetchSearch } from '../../network/product.network';
const { Search } = Input;
class Header extends Component { 

    state = {
        showSearch : false
    }

    componentDidMount() {
        // if(this.props.location.pathname.includes('/profile')){
        //     this.setState({}) 
        // }
        if(this.props.brandList?.length === 0){ 
            fetchHome((res) => { 
                this.props.dispatch(setBrandsList(res.data.data.brands));
              }, (error) => {
                console.log(error)
              })
            
          }
    }
    

    handelMenuSelect = (val) => {
        if(val.key === "3"){
            console.log(this.props)  
            localStorage.removeItem("token")
            this.props.dispatch(setCurrentUser(null))   
            this.props.dispatch(setAddressUser(null))   
            this.props.dispatch(setPaymentUser(null))    
            this.props.dispatch(clearCart()); 
            if(this.props.location.pathname.includes('/profile') || this.props.location.pathname.includes('/checkout')){
                this.props.history.push("/");
            }
            if(this.props.location.pathname.includes('/cart')){
                setTimeout(() => {
                    window.location.reload(); 
                }, 400)
                
            }
        }
    }
    
    changeLang = (lang) => { 
        // document.getElementsByTagName("html")[0].setAttribute("lang", lang);
        localStorage.setItem('lang', lang); 
        this.props.dispatch(setCurrentLang(lang)); 
        this.props.dispatch(setBrandsList([]));
        setTimeout(() => {
            window.location.reload();
        }, 300)
    }

    handelOpenMenu = (openMenu = true) => {
        if(openMenu){
            document.getElementsByClassName("main-header-bottom")[0].classList.add("active");
        }else{
            document.getElementsByClassName("main-header-bottom")[0].classList.remove("active");
        }
    }
    onSearchChange = (e) => { 
        console.log(e.target.value)
        if(!e.target.value){
            this.setState({showSearch : false})
        }else{
         
        }
    }

    onSearch = (value) => {
        console.log("onSearch")
        console.log(value) 
        if(!value){ 
            this.setState({showSearch : false})
        }else{
            this.props.history.replace(`/search/${value}`); 
            this.props.history.push(`/search/${value}`); 
        }
        // let params = value; 
        // console.log(params); 
        // fetchSearch(
        //   params, 
        //   (res) => {
        //     console.log(res); 
        //   },
        //   (error) => {console.log(error); this.setState({loading : false}) }
        // )
    }

    render() {
        const {showSearch} = this.state; 
        const {currentUser, currentLang, currentAddress, brandList} = this.props; 
        return (
            <div className="main-header">
                <div className="container"> 
                   
                    { showSearch &&
                        <div className="search-show-wrapper"> 
                            <Search placeholder="" allowClear onSearch={this.onSearch} onChange={this.onSearchChange} enterButton  />  
                        </div>
                    }
                    <div className="main-header-content">
                        <div className="main-header-top">
                           
                        <AlignLeftOutlined onClick={this.handelOpenMenu} className="bars-menu-icon" />
                        <div className="lang-search">
                            {currentUser && <h5 className="support-text">
                                <PhoneOutlined />
                                <Link to="/support"> 
                                    {localization.Support[currentLang]} 
                                </Link>
                            </h5>}
                            {currentLang === "en" ? 
                            <p className="lang-holder" onClick={ () => this.changeLang("ar")}>
                                AR
                            </p> : 
                            <p className="lang-holder" onClick={ () => this.changeLang("en")}> 
                                EN
                            </p>
                            }
                            <div className="search-input-holder" onClick={ () => this.setState({showSearch : true}) }>
                            {/* <AutoComplete
                                // options={["sdf", "wwwww", "waasw"]}
                                style={{
                                width: 200,
                                }}
                                // onSelect={onSelect}
                                // onSearch={onSearch}
                                // placeholder="input here"
                            >
                                <Input size="large" placeholder={localization.Search[currentLang]}  prefix={<SearchOutlined />} />
                                </AutoComplete> */}
                                <img src={search_icon} alt="" /> 
                            </div>
                            {currentAddress && 
                            <div className="user-adderss-holder">
                                <img src={location_icon} alt="" />
                                <p>
                                {currentAddress.city_name + ", Street No. " + currentAddress.street_number + ", floor " + currentAddress.floor + "," + currentAddress.landmark }  
                                { ", " + currentAddress.note && currentAddress.note} 
                                </p>
                            </div>
                            }
                        </div>
                        <Link to="/">
                            <img src={logo} alt="logo" />
                        </Link>
                        <div className="cart-login">
                            <div className="cart-holder">
                                <Link to="/cart">
                                    {localization.cart[currentLang]}  
                                    <Badge count={this.props.cartItems.length} size="small"> 
                                        <ShoppingCartOutlined />
                                        {/* <img src={cart_icon} alt="" />  */}
                                    </Badge>
                                </Link> 
                            </div>
                            {currentUser ? 
                        <Dropdown overlayClassName="user-dropdown-wrapper" trigger={['click']} overlay={ 
                        <Menu onClick={this.handelMenuSelect}>
                        <Menu.Item key="1" icon={<UserOutlined />}> 
                        <Link to="/profile">{localization.Profile[currentLang]}</Link>
                        </Menu.Item>
                        <Menu.Item key="2" icon={<ShoppingCartOutlined />}> 
                        <Link to={`/profile/3/${localization.ordrers[currentLang]}`}>{localization.Myordrers[currentLang]}</Link> 
                        </Menu.Item>
                        <Menu.Item key="3" icon={<ImportOutlined />} style={{color: "#fe5252"}}> 
                        {localization.Logout[currentLang]} 
                        </Menu.Item> 
                      </Menu>
                    } className="login-dropdown">
                            <Button type="text"> 
                            {this.props.currentUser?.first_name || ""} {this.props.currentUser?.last_name || ""}  <CaretDownOutlined />  
                            </Button>
                        </Dropdown> : <Link to="/login" className="login-link">{localization.Signin[currentLang]}</Link>  
                        }
                        </div> 
                    </div>
                    <div className="main-header-bottom">
                        <CloseOutlined className="close-icon-menu" onClick={() => this.handelOpenMenu(false)} />
                        <ul>
                            <li className="logo-res-menu">
                                <Link to="/"><img src={logo} alt="logo" /></Link>
                            </li>
                            {brandList?.map(brand => 
                            <li key={brand.id}>
                                <Link to={`/brand/${brand.id}/${brand.name}`} key={brand.id}>{brand.name}</Link>
                            </li>
                            )}
                            {/* <li>
                                <Link>About </Link>
                            </li> */}
                            <li className="offer-link">
                                <Link to="/offers">{localization.Offers[currentLang]}</Link>
                            </li>
                        </ul> 
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}
const HeaderWithRouter = withRouter(Header);
const mapStateToProps = (state) => ({
    currentUser : state.user.currentUser,
    currentLang : state.user.currentLang,
    currentAddress : state.user.currentAddress,
    brandList : state.user.brandList || [], 
    cartItems: state.cart.cartItems,
}) 
  
export default connect(mapStateToProps)(HeaderWithRouter);  